import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { ActivityPlanningCards } from './activityplanning.models';
import { formatMoney, formatNumber, formatPercent } from './activityplanning.normalizers';

type Props = { cards?: ActivityPlanningCards | null };

const BudgetImpactPanel: React.FC<Props> = ({ cards }) => {
  const items = [
    ['Activity Total', formatMoney(cards?.activitytotal)],
    ['Task Total', formatMoney(cards?.tasktotal)],
    ['Budget Total', formatMoney(cards?.budgettotal)],
    ['Variance', formatMoney(cards?.variance)],
    ['Weighted Progress', formatPercent(cards?.weightedprogress)],
    ['Tasks', formatNumber(cards?.taskcount)],
    ['Budget Lines', formatNumber(cards?.budgetlinecount)],
  ];

  return (
    <Grid container spacing={2}>
      {items.map(([label, value]) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={label}>
          <Card elevation={1}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">{label}</Typography>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>{value}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default BudgetImpactPanel;
